import { useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import { SMTFallbackUIConfig } from "@/constants/SMT";
import type { SMTImagePickerModalProps } from "@/ui/components/smt/SMTImagePickerModal";
import SMTImagePickerModal from "@/ui/components/smt/SMTImagePickerModal";
import { Button } from "@/ui/core";
import { VStack } from "@/ui/layout";

const StoryMeta: Meta<SMTImagePickerModalProps> = {
  title: "Components/SMT/SMT Image Picker Modal",
  component: SMTImagePickerModal,
  argTypes: {
    onAssetPickerLaunch: { action: "asset picker launched" },
    onAssetSelected: { action: "asset selected" },
    onDismiss: { action: "dismissed" },
    onSkipPhoto: { action: "skipped photo" },
    uiConfig: { control: "object" },
  },
  args: {
    uiConfig: SMTFallbackUIConfig.addFood.addPhoto,
  },
  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const {
      onAssetPickerLaunch,
      onAssetSelected,
      onDismiss,
      onSkipPhoto,
      uiConfig,
    } = args;

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleAssetPickerLaunch = () => {
      onAssetPickerLaunch();
      setIsOpen(false);
    };

    const handleAssetSelected = (asset: FilePickerAsset) => {
      setIsOpen(false);
      onAssetSelected(asset);
    };

    const handleDismiss = () => {
      setIsOpen(false);
      onDismiss();
    };

    const handleSkipPhoto = () => {
      setIsOpen(false);
      onSkipPhoto();
    };

    return (
      <>
        <VStack alignItems="center" width="100%">
          <Button
            onPress={() => setIsOpen(true)}
            testID=""
            title="Open SMT Image Picker Modal"
          />
        </VStack>

        <SMTImagePickerModal
          isOpen={isOpen}
          onAssetPickerLaunch={handleAssetPickerLaunch}
          onAssetSelected={handleAssetSelected}
          onDismiss={handleDismiss}
          onSkipPhoto={handleSkipPhoto}
          uiConfig={uiConfig}
        />
      </>
    );
  },
};

type Story = StoryObj<SMTImagePickerModalProps>;

const Default: Story = {};

export { Default };
export default StoryMeta;
